/**
 * Environment Configuration
 * Automatically detects environment and configures API endpoints
 */

// Detect environment
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development' ||
                     window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1';

// API Base URLs for different environments
const API_ENDPOINTS = {
  development: {
    RECOMMENDATION_API: 'http://localhost:3001/api/recommendations',
    MAIN_API: 'http://localhost:3001/api',
    BACKEND_HOST: 'localhost:3001'
  },
  production: {
    RECOMMENDATION_API: 'https://api.labcat.com.cn/api/recommendations',
    MAIN_API: 'https://api.labcat.com.cn/api',
    BACKEND_HOST: 'api.labcat.com.cn'
  },
  staging: {
    RECOMMENDATION_API: 'https://staging-api.labcat.com.cn/api/recommendations',
    MAIN_API: 'https://staging-api.labcat.com.cn/api',
    BACKEND_HOST: 'staging-api.labcat.com.cn'
  }
};

// Get current environment (cached for performance)
const getCurrentEnvironment = (() => {
  let cachedEnv = null;

  return () => {
    if (cachedEnv) return cachedEnv; // Return cached result

    if (isProduction) {
      // Check if we're on a staging domain
      if (window.location.hostname.includes('staging')) {
        cachedEnv = 'staging';
      } else {
        cachedEnv = 'production';
      }
    } else {
      cachedEnv = 'development';
    }

    return cachedEnv;
  };
})();

const currentEnv = getCurrentEnvironment();
const config = API_ENDPOINTS[currentEnv];

// Export configuration
export const ENV_CONFIG = {
  ENVIRONMENT: currentEnv,
  IS_DEVELOPMENT: isDevelopment,
  IS_PRODUCTION: isProduction,

  // API Endpoints
  RECOMMENDATION_API_BASE: config.RECOMMENDATION_API,
  MAIN_API_BASE: config.MAIN_API,
  BACKEND_HOST: config.BACKEND_HOST,

  // Feature flags based on environment
  FEATURES: {
    DEVELOPMENT_INDICATOR: isDevelopment,
    SSH_TUNNEL_INFO: isDevelopment,
    DEBUG_LOGS: isDevelopment,
    MOCK_DATA: isDevelopment && window.location.search.includes('mock=true')
  }
};

// Console log for development
if (isDevelopment) {
  console.log('🔧 Environment Configuration:', ENV_CONFIG);
}

export default ENV_CONFIG;